export enum sidebarRoutes {
  HOME = 'HOME',
  PIX = 'PIX',
  CARDS = 'CARDS',
  TRANSFERS = 'TRANSFERS',
  EXTRACT = 'EXTRACT',
  PAYABLE = 'PAYABLE',
  FILES_HANDLER = 'FILES_HANDLER',
  RECEIVABLE = 'RECEIVABLE',
  CASHBACK = 'CASHBACK',
  ESCROW = 'ESCROW',
  LOAN = 'LOAN',
  PROFILE = 'PROFILE',
  INVESTMENTS = 'INVESTMENTS',
  EMPLOYEES = 'EMPLOYEES',
  PAYLISP = 'PAYLISP',
}
